module.exports = __webpack_public_path__ + "img/ug562.1bc015f1.png";